package ui.pages

import emotion.react.css
import react.FC
import react.dom.html.ReactHTML
import ru.malygin.myConst.OnTopVariable
import ui.styles.Styles
import web.cssom.*

val Footer = FC {
    ReactHTML.footer {
        className = Styles.Footer.FooterBox

        css(this.className) {
            paddingInline = 20.px
        }

        ReactHTML.div{
            css {
                gridArea = Area.FooterBox.center
            }


            ReactHTML.span{
                css {
                    height = 100.pct
                    display = Display.flex
                    justifyContent = JustifyContent.center
                    alignItems = AlignItems.center
                    color = Color("white")
                }
                +"версия: ${OnTopVariable.APP_VERSION}"
            }
        }

        ReactHTML.div{
            css {
                gridArea = Area.FooterBox.right
                display = Display.flex
                justifyContent = JustifyContent.end
            }
        }

        ReactHTML.div{
            css {
                gridArea = Area.FooterBox.left
                display = Display.flex
                justifyContent = JustifyContent.start
            }
        }
    }
}